import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { TeamSettingsMembersViewTopBar } from "./TopBar"

export const teamSettingsMembersViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: TeamSettingsMembersViewTopBar,
}
